import useTranslator from "@hooks/use-translator";
import { Loader } from "lucide-react";

interface Props {
  label?: string;
  className?:string
}
const PmsLoader = ({ label ,className='min-h-[20vh]'}: Props) => {
  const { translate } = useTranslator();

  return (
    <div className={`flex ${className} h-auto w-full items-center justify-center`}>
      <div className="flex flex-col items-center">
        <Loader className="animate-spin text-3xl text-primary" />
        <span className="text-sm text-slate-100/50 mt-2">
          {label && translate(label)}
        </span>
      </div>
    </div>
  );
};

export default PmsLoader;
